import React from 'react';

const DeleteConfirmationModal = ({ onConfirm, onCancel, leadName }) => (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-sm">
            <h3 className="text-lg font-bold">Confirmar Eliminación</h3>
            <p className="my-4 text-gray-600">¿Estás seguro de que quieres eliminar a <strong>{leadName}</strong>? Esta acción no se puede deshacer.</p>
            <div className="flex justify-end gap-4">
                <button onClick={onCancel} className="px-4 py-2 text-sm font-medium bg-gray-200 rounded-md hover:bg-gray-300">Cancelar</button>
                <button onClick={onConfirm} className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700">Eliminar</button>
            </div>
        </div>
    </div>
);

export default DeleteConfirmationModal;

